var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemBadgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2h10v7.85q0 .575-.25 1.025-.25.45-.7.725l-3.55 2.1.7 2.3H17l-3.1 2.2 1.2 3.8-3.1-2.35L8.9 22l1.2-3.8L7 16h3.8l.7-2.3-3.55-2.1q-.45-.275-.7-.725Q7 10.425 7 9.85Zm2 2v5.85l2 1.2V4Zm6 0h-2v7.05l2-1.2Zm-3 3.825Zm-1-.3Zm2 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemBadgeIcon);
export default __webpack_public_path__ + "static/media/ItemBadgeIcon.13aafda6.svg";
export { ForwardRef as ReactComponent };